import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { type IPractice } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { BridgeDiagnosticStatusComponent } from './diagnostic-status/diagnostic-status.component';
import { BridgeConfigConflictsComponent } from './config-conflicts/config-conflicts.component';

export interface IBridgeDiagnosticsDialogData {
  practice: WithRef<IPractice>;
}

export enum BridgeDiagnosticsPage {
  DiagnosticStatus = 'diagnostic-status',
  ConfigConflicts = 'config-conflicts',
}

@Component({
  selector: 'pt-bridge-diagnostics-dialog',
  templateUrl: './bridge-diagnostics-dialog.component.html',
  styleUrls: ['./bridge-diagnostics-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgDialogModule,
    MatListModule,
    MatIconModule,
    BridgeDiagnosticStatusComponent,
    BridgeConfigConflictsComponent,
  ],
})
export class BridgeDiagnosticsDialogComponent {
  data = inject<IBridgeDiagnosticsDialogData>(MAT_DIALOG_DATA);

  readonly BridgeDiagnosticsPage = BridgeDiagnosticsPage;
  activePage = signal<BridgeDiagnosticsPage>(
    BridgeDiagnosticsPage.DiagnosticStatus
  );

  selectPage(page: BridgeDiagnosticsPage): void {
    this.activePage.set(page);
  }
}
